import { VIEW_TYPE } from '@shared/constants/dashboard/campaign-table-constants';

export const initialsName = (fullName = '') => (
    fullName.split(' ').map((separateName, index) => ((index < 2) ? separateName[0] : '')).join('')
);

export const textSegmentsByTeam = segmentsByTeam => (segmentsByTeam > 0 ? ` and ${segmentsByTeam} by your team` : '');

// eslint-disable-next-line complexity
export const sortSegmentsByType = (segmentA, segmentB) => {
    if (isStandardSegment(segmentA)) return -1;
    if (isStandardSegment(segmentB)) return 1;
    if (isCampaignTypeSegment(segmentA)) return -1;
    if (isCampaignTypeSegment(segmentB)) return 1;
    if (isBudgetManagerSegment(segmentA)) return -1;
    if (isBudgetManagerSegment(segmentB)) return 1;

    return segmentA.id - segmentB.id;
};

const isStandardSegment = segment => segment.slug === VIEW_TYPE.standard;

const isCampaignTypeSegment = segment => segment.slug === VIEW_TYPE.campaignType;

const isBudgetManagerSegment = segment => segment.name === 'Budget Manager Automation';
